// extracted by mini-css-extract-plugin
export default {"fullWidth":"dp-z","image":"ep-z","lazyLoadPicture":"fp-z","lazyLoadSpinner":"gp-z","lazyLoadSpin":"hp-z","lazyLoadImage":"ip-z","hasStyledAspectRatio":"jp-z"};